<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.transferencia.recebida"
            :tbody-tr-class="rowClass"
            class="table-resultado"
            ref="DataTable"
            search-by="unidadeNomeFantasia"
            sort-by="dataTransferencia"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click.stop="$refs.ModalTransferencia.open(item)"
                    authorize="update-almoxarifado-transferencia"
                    color="primary"
                    small
                    title="Visualizar"
                >
                    <rkm-icon icon="eye" />
                </rkm-button>
            </template>

            <template #afterPagination>
                <div class="mt-2">
                    <p class="mb-0">A linha em <span class="green">verde</span> representa que a transferência foi aceita.</p>
                    <p>A linha em <span class="red">vermelho</span> representa que a transferência foi recusada.</p>
                </div>
            </template>
        </rkm-data-table>

        <ModalTransferencia
            @save="$refs.DataTable.refresh()"
            ref="ModalTransferencia"
        />
    </div>
</template>

<script>
// Components.
import ModalTransferencia from './components/transferencia/Modal'

// Mixins.
import { repository } from '@/mixins'

export default {
    components: { ModalTransferencia },
    created() {

        this.repositories = {
            transferencia: this.getConectaSusRepository('almoxarifado.transferencia'),
        }
    },
    computed: {
        fields() {

            return [
                {
                    name: 'almoxarifadoSaida.createdAt',
                    key: 'dataTransferencia',
                    label: 'Data da transferência',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroUnidade.nomeFantasia',
                    key: 'unidadeNomeFantasia',
                    label: 'Unidade',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroInfraestrutura.nome',
                    key: 'infraestruturaNome',
                    label: 'Local de atendimento',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroSetor.nome',
                    key: 'setorNome',
                    label: 'Setor',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroCidadao.nome',
                    key: 'usuarioNome',
                    label: 'Usuário (Destino)',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]
        }
    },
    methods: {
        rowClass(item, type) {

            if (type === 'row' && item) {

                if (item.confirmado) {

                    return 'table-success'
                }
                else if (item.recusado) {

                    return 'table-danger'
                }
            }
        },
    },
    mixins: [ repository ],
}
</script>

<style scoped>
.table-resultado >>> .green { color: green; }
.table-resultado >>> .red { color: red; }
</style>